<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2 7 9h3l-4 6h4l-3 6h10l-3-6h4l-4-6h3L12 2Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 21v-2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>
</template>
